// eslint-disable-next-line import/no-cycle
import { classNameWithModifier } from '@slickdeals/durango/dist/javascript/utilities/css';
import BlueprintComponent from '../core/blueprintComponent';
import '../../scss/components/checkbox.scss';
/** The name of the module */
export const name = 'Checkbox';
export var ClassNames;
(function (ClassNames) {
    ClassNames["Default"] = "bp-c-checkbox";
    ClassNames["JavaScript"] = "js-checkbox";
})(ClassNames || (ClassNames = {}));
/**
 * @deprecated Use ClassNames enum instead
 *
 * The CSS selector for use in selector lookups in scripts
 */
export const JS_SELECTOR = 'js-checkbox';
/**
 * @deprecated use ClassNames enum instead
 *
 *  The base CSS classname for this module
 */
export const CSS_CLASSNAME = 'bp-c-checkbox';
/** Available modifiers for this module */
export var Modifiers;
(function (Modifiers) {
    Modifiers["Hidden"] = "hidden";
})(Modifiers || (Modifiers = {}));
export default class Checkbox extends BlueprintComponent {
    constructor(options) {
        super(name, options);
    }
    async init() {
        if (typeof this.element === 'undefined') {
            this.element = await BlueprintComponent.loadElement(name, this.options);
        }
        if (typeof this.element === 'undefined') {
            throw new Error('Checkbox element is undefined');
        }
    }
    /**
       * Create a checkbox element with style modifiers
       *
       * @param {String[]} options - Array of modifiers to apply to the new element (as dictated by the modifiers enum)
       *
       * @return {CheckboxElement}
       */
    static createElement(options = []) {
        // Create the HTMLElement to build off of
        const element = document.createElement('input');
        // Set the input type to a checkbox
        element.type = 'checkbox';
        // Add the base class name
        element.classList.add(CSS_CLASSNAME);
        // Attach any modifier classes
        options.forEach((option) => element.classList.add(classNameWithModifier(CSS_CLASSNAME, option)));
        return element;
    }
}
